(() => {



	let HeaderNav = document.getElementById('st-header_nav');
	let HeaderFrag = false;
	let HeaderBtnOpen = document.getElementById('st-header_btn-open');
	let HeaderBtnClose = document.getElementById('st-header_btn-close');

	HeaderBtnOpen.addEventListener('click', () => {
		if(!HeaderFrag){
			HeaderNav.className = 'st-header_nav st-header_nav-visible';
			HeaderFrag = true;
		}
	}, false);

	HeaderBtnClose.addEventListener('click', () => {
		if(HeaderFrag){
			HeaderNav.className = 'st-header_nav st-header_nav-hidden';
			HeaderFrag = false;
		}
	}, false);



	let topBtn = document.getElementById('st-top');

	window.addEventListener('scroll', () => {
		if(window.pageYOffset > 100) {
			topBtn.className = 'st-top st-top-visible';
		} else {
			topBtn.className = 'st-top st-top-hidden';
		}
	}, false);



	$("a[href^=#]").on("click", function(){
		var linkSpeed = 800;
		var linkHref = $(this).attr("href");
		if(window.innerWidth > 768) {
			var headerHeight = 100;
		} else {
			var headerHeight = 0;
		}

		var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
		var linkPosition = linkTarget.offset().top - headerHeight;
		console.log(headerHeight);
		$("html, body").animate({scrollTop: linkPosition}, linkSpeed, "swing");

		return false;
	});



})();



// WEBPACK FOOTER //
// script.js